export const benefitData = [
	{
		icon: '👗',
		title: 'benefitData_title1',
		subtitle: 'benefitData_subtitle1',
	},
	{
		icon: '👩‍💻',
		title: 'benefitData_title2',
		subtitle: 'benefitData_subtitle2',
	},
	{
		icon: '🏠',
		title: 'benefitData_title3',
		subtitle: 'benefitData_subtitle3',
	},
	{
		icon: '📚',
		title: 'benefitData_title4',
		subtitle: 'benefitData_subtitle4',
	},
	{
		icon: '💁‍♀️',
		title: 'benefitData_title5',
		subtitle: 'benefitData_subtitle5',
	},
];
